// src/components/projectDetails/ProjectActivation.js
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  TextField,
  Button,
  Paper,
  Box,
  Typography,
  Alert,
  useTheme,
} from "@mui/material";
import { io } from "socket.io-client";
// Helper to parse query parameters
const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const ProjectActivation = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const project_id = query.get("project_id");
  // Save the invoked_project_id for later usage
  localStorage.setItem("invoked_project_id", project_id);
  const theme= useTheme();
  const token =localStorage.getItem("access_token");
  const [socketMessage, setSocketMessage] = useState(null);
  // const [activationStatus, setActivationStatus] = useState(null);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("info");
  const [socket, setSocket] = useState(null);

  // Establish socket connection on component mount
  useEffect(() => {
    const newSocket = io(`${process.env.REACT_APP_API_NEW_HOST_URL}/athrv/api/v1/github`, {
      transports: ['websocket'],
    });
    setSocket(newSocket);

    // Clean up on unmount
    return () => newSocket.disconnect();
  }, []);

  // Listen for "activationStatus" events from the backend
  useEffect(() => {
    if (!socket || !project_id) return;
    const handleActivationStatus = (data) => {
      // Only process events for the current project_id
      if (data.project_id === project_id) {
        // setActivationStatus(data.success ? "Activated" : "Failed");
        alert('message:', data);
        setSocketMessage(data);
        setAlertMessage(data.message);
        setAlertSeverity(data.success ? "success" : "error");
      }
    };
    socket.on("activationStatus", handleActivationStatus);

    // Clean up listener on unmount or change of dependencies
    return () => {
      socket.off("activationStatus", handleActivationStatus);
    };
  }, [socket, project_id]);

  // // Handler for Permit Access button click
  // const handlePermitAccess = () => {
  //   // Prepare a state parameter with project_id and returnUrl
  //   const stateData = encodeURIComponent(
  //     JSON.stringify({ project_id, returnUrl: window.location.href })
  //   );
  //   // Build the GitHub installation URL (replace with your app's slug)
  //   const githubInstallUrl = `https://github.com/apps/${process.env.REACT_APP_GITHUB_APP_SLUG}/installations/new?state=${stateData}`;
  //   // Open GitHub installation in a new tab
  //   window.open(githubInstallUrl, "_blank");
  // };
  // Handler for Permit Access button click
  const handlePermitAccess = () => {
    // First, invoke /invoke-setup-project-repository to mark project as "invoked"
    fetch(`${process.env.REACT_APP_API_NEW_HOST_URL}/athrv/api/v1/github/invoke-setup-project-repository`, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      body: JSON.stringify({ project_id })
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setAlertMessage(data.message);
          setAlertSeverity("info");
          // Prepare state with project_id and returnUrl for GitHub installation redirection
          const stateData = encodeURIComponent(JSON.stringify({ project_id, returnUrl: window.location.href }));
          const githubInstallUrl = `https://github.com/apps/${process.env.REACT_APP_GITHUB_APP_SLUG}/installations/new?state=${stateData}`;
          window.open(githubInstallUrl, "_blank");
        } else {
          setAlertMessage("Failed to mark project as invoked. Please retry.");
          setAlertSeverity("error");
        }
      })
      .catch((err) => {
        console.error("Error invoking setup-project-repository:", err);
        setAlertMessage("Error invoking setup. Please retry.");
        setAlertSeverity("error");
      });
  };

  // Handler for Retry button if activation fails
  const handleRetry = () => {
    setAlertMessage("");
    setSocketMessage(null);
    // You could simply refresh the page or call handlePermitAccess again
    handlePermitAccess();
  };

  // Handler for finishing setup after successful activation
  const handleFinishSetup = () => {
    navigate(`/projects/${project_id}`);
  };

  return (
    <Box
          sx={{
            minHeight: "100vh",
            backgroundColor: theme.palette.mode === "dark" ? "#2c2b2b" : "#f5f5f5",
            padding: 3,
            m: 0,
          }}
        >
    <>
      
      <Paper sx={{ p: 2, maxWidth: 600, margin: "20px auto" }}>
        <Typography variant="h6" gutterBottom>
          Activate Your GitHub Repository
        </Typography>
        <Typography variant="body1">Project ID: {project_id}</Typography>
        <Box sx={{ my: 2 }}>
          <Button
            variant="contained"
            className="athrv-dash-primary-button"
            onClick={handlePermitAccess}
            sx={{ my: 2 , backgroundColor: theme.palette.mode === 'dark' ? '#263d68' : undefined,}}
          >
            Permit Access
          </Button>
          <Button
            variant="contained"
            className='athrv-dash-primary-button'
            onClick={() => {
              console.log("Navigating with activeTab = 1");
              navigate(`/projects/${project_id}`);
            }}
            sx={{ m: 2, backgroundColor: theme.palette.mode === 'dark' ? '#263d68' : undefined, }}
          >
            Back to Project Details
          </Button>
        </Box>
        <Typography>This is a secure communication from AWS via GitHub.</Typography>
        {alertMessage && (
          <Alert severity={alertSeverity} sx={{ mb: 2 }}>
            {alertMessage}
          </Alert>
        )}
        {socketMessage && alertSeverity === "error" && (
          <Box sx={{ mt: 2 }}>
            <Button variant="outlined" onClick={handleRetry}>
              Retry
            </Button>
          </Box>
        )}
        {socketMessage && alertSeverity === "success" && (
          <Box sx={{ mt: 2 }}>
            <Button variant="outlined" onClick={handleFinishSetup}>
              Finish Project Setup
            </Button>
          </Box>
        )}
      </Paper>

    </>
    </Box>
  );
};

export default ProjectActivation;
